import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://dashbound.media';
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || 'https://www.trafficdots.com/login.php';

export const api = axios.create({
  baseURL: API,
  timeout: 30000,
});

export const ADMIN_TOKEN_KEY = 'dashbound_admin_token';

export function getAdminToken() {
  try { return localStorage.getItem(ADMIN_TOKEN_KEY) || ''; } catch { return ''; }
}
export function setAdminToken(token) {
  try { localStorage.setItem(ADMIN_TOKEN_KEY, token); } catch {}
}
export function clearAdminToken() {
  try { localStorage.removeItem(ADMIN_TOKEN_KEY); } catch {}
}

export function adminHeaders() {
  const t = getAdminToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}
